<template>
    <div>
        <table class="table w-full">
            <thead>
                <tr>
                    <sortable-header @sort="handleSort" sort-by="name" :direction="sort_direction" :column="sort_column" class="text-left border-b-2 border-gray py-2 px-2">Name</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="order_count" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2"># of Orders</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="last_sale" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Last Sale</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="subtotal" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Subtotal</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="delivery_fee" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Delivery Fee</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="tax" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Tax</sortable-header>
                    <sortable-header @sort="handleSort" sort-by="total" :direction="sort_direction" :column="sort_column" class="text-right border-b-2 border-gray py-2 px-2">Total</sortable-header>
                </tr>
            </thead>
            <tbody>
                <tr v-for="customer in data" :key="customer.id">
                    <td>{{ customer.name }}</td>
                    <td class="text-right">{{ customer.order_count }}</td>
                    <td class="text-right">{{ customer.last_sale }}</td>
                    <td class="text-right">{{ toCurrency(customer.subtotal) }}</td>
                    <td class="text-right">{{ toCurrency(customer.delivery_fee) }}</td>
                    <td class="text-right">{{ toCurrency(customer.tax) }}</td>
                    <td class="text-right">{{ toCurrency(customer.total) }}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class=""></td>
                    <td class="text-right">{{ totalCount }}</td>
                    <td class="text-right"></td>
                    <td class="text-right">{{ toCurrency(totalSubtotal) }}</td>
                    <td class="text-right">{{ toCurrency(totalDeliveryFee) }}</td>
                    <td class="text-right">{{ toCurrency(totalTax) }}</td>
                    <td class="text-right">{{ toCurrency(totalTotal) }}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>

import SortableHeader from '@/Shared/SortableHeader';

export default {
    components: {
        SortableHeader,
    },

    props: ['data', 'sort_column', 'sort_direction'],
    emits: ['sort'],

    methods: {
        handleSort (sort) {
            this.$emit('sort', sort);
        },
    },

    computed: {
        totalCount() {
            return this.data.reduce(function(accumulator, customer){
                return accumulator + Number(customer.order_count);
            }, 0);
        },
        totalSubtotal() {
            return this.data.reduce(function(accumulator, customer){
                return accumulator + Number(customer.subtotal);
            }, 0);
        },
        totalDeliveryFee() {
            return this.data.reduce(function(accumulator, customer){
                return accumulator + Number(customer.delivery_fee);
            }, 0);
        },
        totalTax() {
            return this.data.reduce(function(accumulator, customer){
                return accumulator + Number(customer.tax);
            }, 0);
        },
        totalTotal() {
            return this.data.reduce(function(accumulator, customer){
                return accumulator + Number(customer.total);
            }, 0);
        }
    }

}
</script>
